import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

// Worker is served from /public — no CDN dependency, no Vite module resolution needed
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

interface PdfPreviewProps {
  url: string;
}

export function PdfPreview({ url }: PdfPreviewProps) {
  const [numPages, setNumPages] = useState<number>(0);

  const pageWidth = Math.min(window.innerWidth - 64, 800);

  return (
    <div className="h-full overflow-y-auto">
      <Document
        file={url}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        loading={
          <div className="flex h-32 items-center justify-center">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-600 border-t-brand-400" />
          </div>
        }
        error={
          <p className="py-12 text-center text-sm text-red-400">Failed to load PDF file.</p>
        }
        className="flex flex-col items-center gap-4 py-4"
      >
        {Array.from({ length: numPages }, (_, i) => (
          <Page
            key={i + 1}
            pageNumber={i + 1}
            width={pageWidth}
            renderAnnotationLayer
            renderTextLayer
            className="shadow-lg"
          />
        ))}
      </Document>
    </div>
  );
}
